(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('inst-claim-conf', {
                parent: 'entity',
                url: '/inst-claim-conf',
                data: {
                    authorities: [],
                    pageTitle: 'InstClaimConfs'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/inst-claim-conf/inst-claim-confs.html',
                        controller: 'InstClaimConfController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_INST_CLAIM_CONF];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_INST_CLAIM_CONF, access);
                }]
            })
            .state('inst-claim-conf.new', {
                parent: 'inst-claim-conf',
                url: '/new',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_INST_CLAIM_CONF, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/inst-claim-conf/inst-claim-conf-dialog.html',
                            controller: 'InstClaimConfDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'lg',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['CoreService', function (CoreService) {
                                    var facility = CoreService.getCurrentFacility();

                                    return {
                                        minTime: null,
                                        maxTime: null,
                                        isDefault: false,
                                        rate: null,
                                        quantity: null,
                                        unit: null,
                                        id: null,
                                        facility: facility,
                                        instCptConfs: [{}]
                                    };
                                }]
                            }
                        }).result.then(function () {
                            $state.go('inst-claim-conf', null, {reload: 'inst-claim-conf'});
                        }, function () {
                            $state.go('inst-claim-conf');
                        });
                    }
                }]
            })
            .state('inst-claim-conf.edit', {
                parent: 'inst-claim-conf',
                url: '/{id}/edit',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_INST_CLAIM_CONF, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/inst-claim-conf/inst-claim-conf-dialog.html',
                            controller: 'InstClaimConfDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'lg',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['InstClaimConf', function (InstClaimConf) {
                                    return InstClaimConf.get({id: $stateParams.id}).$promise;
                                }]
                            }
                        }).result.then(function () {
                            $state.go('inst-claim-conf', null, {reload: 'inst-claim-conf'});
                        }, function () {
                            $state.go('^');
                        });
                    }
                }]
            })
            .state('inst-claim-conf.delete', {
                parent: 'inst-claim-conf',
                url: '/{id}/delete',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_INST_CLAIM_CONF, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/inst-claim-conf/inst-claim-conf-delete-dialog.html',
                            controller: 'InstClaimConfDeleteController',
                            controllerAs: 'vm',
                            size: 'md',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['InstClaimConf', function (InstClaimConf) {
                                    return InstClaimConf.get({id: $stateParams.id}).$promise;
                                }]
                            }
                        }).result.then(function () {
                            $state.go('inst-claim-conf', null, {reload: 'inst-claim-conf'});
                        }, function () {
                            $state.go('^');
                        });
                    }
                }]
            });
    }
})();
